export default function WhatIs() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1">
            <div
              className="w-full h-[300px] md:h-[400px] rounded-2xl overflow-hidden"
            >
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20workspace%20scene%20featuring%20a%20laptop%20displaying%20a%20clean%20organized%20spreadsheet%20layout%2C%20surrounded%20by%20carefully%20arranged%20fashion%20items%20including%20a%20folded%20sweater%20and%20leather%20accessories%20on%20a%20light%20oak%20desk%2C%20soft%20morning%20light%20from%20a%20nearby%20window%2C%20Scandinavian%20interior%20aesthetic%2C%20cream%20and%20sand%20tones%2C%20cozy%20productive%20atmosphere%2C%20editorial%20lifestyle%20photography%20with%20natural%20composition&width=800&height=600&seq=kakobuy-whatis-v2-01&orientation=landscape"
                alt="Kakobuy Spreadsheet - Uporządkowana baza produktów"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-100/70 rounded-full text-xs font-medium text-primary-700 mb-4">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-information-line text-xs"></i>
              </div>
              Podstawy
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-6">
              Czym jest Kakobuy Spreadsheet?
            </h2>

            <div className="space-y-4 text-foreground-600 leading-relaxed">
              <p>
                <strong className="text-foreground-900">Kakobuy Spreadsheet</strong> to uporządkowana baza produktów,
                która pomaga użytkownikom szybciej znaleźć najlepsze produkty,
                porównać opcje i podejmować bardziej świadome decyzje zakupowe.
              </p>
              <p>
                Zamiast przeszukiwać setki losowych stron,
                możesz korzystać z gotowych kategorii,
                rankingów oraz aktualnych list produktów. To narzędzie stworzone przez społeczność dla społeczności –
                każdy może znaleźć to, czego szuka, bez marnowania czasu na niepotrzebne przeglądanie.
              </p>
              <p>
                Niezależnie od tego, czy szukasz sneakersów, ubrań, akcesoriów czy innych produktów –
                Kakobuy Spreadsheet oferuje przejrzysty i łatwy w obsłudze system kategorii, który prowadzi Cię prosto do celu.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}